<template>
	<div>
		<h4 class="section-title">Category Detail</h4>

		<p>Category: {{ category_data.name }}</p>

		<router-link :to="{ name : 'admin.categories.index' }" tag="button" class="button dark-button">Back</router-link>
	    <h3 class="section-title">Tags</h3>
	    <button class="button" @click="create_tag = !create_tag">New tag</button>
	    <div v-show="create_tag">
	    	<form @submit.prevent="onSubmitNewTag()">
	    		<div class="form-group input-content">
					<label>Name</label>
					<input type="text" v-model="new_tag" class="form-control" v-validate="'required'" name="name">
					<span class="input-error-msg">{{ errors.first('name') }}</span>
				</div>
				<button type="submit" class="button">Submit</button>
	    	</form>
	    </div>
	    <div class="table-responsive">
			Showing {{ tags_table.from }} to {{ tags_table.to }} of {{ tags_table.total_rows }}
			<table class="table table-bordered">
				<thead>
					<tr>
						<th class="green-content">Name</th>
						<th class="green-content">Actions</th>
					</tr>
				</thead>
				<tbody>
					<tr v-for="item in category_data.tags" >
						<td>{{ item.name }}</td>
						<td>
							<router-link :to="{ name: 'admin.tags.detail', params : { id : item.id } }" tag="a" class="button">Show</router-link>
		      				<router-link :to="{ name :'admin.tags.edit', params : { id : item.id } }" tag="a" class="button dark-button">Edit</router-link>
						</td>
					</tr>
				</tbody>
			</table>
		</div>
		<b-pagination align="right" :total-rows="tags_table.total_rows" v-model="tags_table.current_page" :per-page="tags_table.per_page" @change="setPageTags">
    	</b-pagination>
	</div>
</template>

<script>
export default {
	data : function(){
		return {
			id : this.$route.params.id,
			category_data : {
				name : '',
				tags : []
			},

			tags_table : {
				current_page : 0,
				total_rows : 0,
				per_page : 0,
				from : 0,
				to : 0
			},
			new_tag : '',
			create_tag : false
		}
	},

	created : function(){
		this.getCategory();
	},

	methods : {
		getCategory : function(){

			var params = {
				id : this.id
			}

			this.$store.dispatch('getCategory', params).then((res) => {
				this.category_data = res.data.data;

				this.getTags();
			}).catch((error) => {
				console.log(error);
			});
		},

		getTags : function(){

			var params = {
				filters : {
					page : this.tags_table.current_page
				},
				id : this.id
			}

			this.$store.dispatch('getCategoryTags', params).then((res) => {
				this.category_data.tags = res.data.data;

				this.tags_table.current_page = res.data.meta.current_page;
				this.tags_table.total_rows = res.data.meta.total;
				this.tags_table.per_page = res.data.meta.per_page;
				this.tags_table.from = res.data.meta.from;
				this.tags_table.to = res.data.meta.to;

			}).catch((error) => {
				console.log(error);
			});
		},
		setPageTags : function(page){
			this.tags_table.current_page = page;

			this.getTags();
		},
		onSubmitNewTag : function(){
			this.$validator.validateAll().then((result) => {
				if(result){
					var params = {
						id : this.id,
						name : this.new_tag
					}

					this.$store.dispatch('addTag', params).then((res) => {
						console.log(res);

						this.new_tag = '';
						this.getTags();
					}).catch((error) => {
						console.log(error);
					});
				}
			});
		}
	}
}
</script>


// WEBPACK FOOTER //
// src/components/admin/categories/AdminCategoryDetailComponent.vue